import { faBuilding as faBuildingRegular } from '@fortawesome/free-regular-svg-icons/faBuilding';
import { faCircleCheck as faCircleCheckRegular } from '@fortawesome/free-regular-svg-icons/faCircleCheck';
import { faCircleXmark as faCircleXmarkRegular } from '@fortawesome/free-regular-svg-icons/faCircleXmark';
import { faComment as faCommentRegular } from '@fortawesome/free-regular-svg-icons/faComment';
import { faCopy as faCopyRegular } from '@fortawesome/free-regular-svg-icons/faCopy';
import { faEnvelope as faEnvelopeRegular } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faFile as faFileRegular } from '@fortawesome/free-regular-svg-icons/faFile';
import { faFloppyDisk as faFloppyDiskRegular } from '@fortawesome/free-regular-svg-icons/faFloppyDisk';
import { faTrashCan as faTrashCanRegular } from '@fortawesome/free-regular-svg-icons/faTrashCan';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons/faArrowRightFromBracket';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons/faArrowsRotate';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBlog } from '@fortawesome/free-solid-svg-icons/faBlog';
import { faBug } from '@fortawesome/free-solid-svg-icons/faBug';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo';
import { faClose } from '@fortawesome/free-solid-svg-icons/faClose';
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons/faCloudArrowUp';
import { faCode } from '@fortawesome/free-solid-svg-icons/faCode';
import { faCodeBranch } from '@fortawesome/free-solid-svg-icons/faCodeBranch';
import { faComment } from '@fortawesome/free-solid-svg-icons/faComment';
import { faCrown } from '@fortawesome/free-solid-svg-icons/faCrown';
import { faDesktop } from '@fortawesome/free-solid-svg-icons/faDesktop';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faFileCircleExclamation } from '@fortawesome/free-solid-svg-icons/faFileCircleExclamation';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faKey } from '@fortawesome/free-solid-svg-icons/faKey';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faListOl } from '@fortawesome/free-solid-svg-icons/faListOl';
import { faLocationCrosshairs } from '@fortawesome/free-solid-svg-icons/faLocationCrosshairs';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon';
import { faPalette } from '@fortawesome/free-solid-svg-icons/faPalette';
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faShare } from '@fortawesome/free-solid-svg-icons/faShare';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faSun } from '@fortawesome/free-solid-svg-icons/faSun';
import { faTableCells } from '@fortawesome/free-solid-svg-icons/faTableCells';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserGroup } from '@fortawesome/free-solid-svg-icons/faUserGroup';
import { faWarning } from '@fortawesome/free-solid-svg-icons/faWarning';

export const fontAwesomeIcons = {
  'arrow-left': faArrowLeft,
  'arrow-right-from-bracket': faArrowRightFromBracket,
  'arrow-right': faArrowRight,
  'arrows-rotate': faArrowsRotate,
  bars: faBars,
  blog: faBlog,
  bug: faBug,
  'building-regular': faBuildingRegular,
  'caret-down': faCaretDown,
  check: faCheck,
  'check-circle': faCheckCircle,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  'circle-check-regular': faCircleCheckRegular,
  'circle-info': faCircleInfo,
  'circle-xmark-regular': faCircleXmarkRegular,
  close: faClose,
  'cloud-arrow-up': faCloudArrowUp,
  code: faCode,
  'code-branch': faCodeBranch,
  comment: faComment,
  'comment-regular': faCommentRegular,
  'copy-regular': faCopyRegular,
  crown: faCrown,
  desktop: faDesktop,
  edit: faEdit,
  'envelope-regular': faEnvelopeRegular,
  eye: faEye,
  'eye-slash': faEyeSlash,
  'file-circle-exclamation': faFileCircleExclamation,
  'file-regular': faFileRegular,
  'floppy-disk-regular': faFloppyDiskRegular,
  'info-circle': faInfoCircle,
  key: faKey,
  link: faLink,
  'list-ol': faListOl,
  'location-crosshairs': faLocationCrosshairs,
  lock: faLock,
  moon: faMoon,
  palette: faPalette,
  pen: faPen,
  plus: faPlus,
  'question-circle': faQuestionCircle,
  share: faShare,
  spinner: faSpinner,
  sun: faSun,
  'table-cells': faTableCells,
  'trash-can-regular': faTrashCanRegular,
  'triangle-exclamation': faTriangleExclamation,
  upload: faUpload,
  user: faUser,
  'user-group': faUserGroup,
  warning: faWarning,
};

export const customIcons = {
  google: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 18 18"
    >
      <path
        d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18Z"
        fill="#4285F4"
      />
      <path
        d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17Z"
        fill="#34A853"
      />
      <path
        d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07Z"
        fill="#FBBC05"
      />
      <path
        d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3Z"
        fill="#EA4335"
      />
    </svg>
  ),
  microsoft: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
    >
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  ),
};
